var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUserEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa-solid:user-edit",
    clipPath: "url(#clip0_6113_1517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.50092 15.5H1.5C0.948017 15.5 0.5 15.052 0.5 14.5V13.2C0.5 11.1574 2.15739 9.5 4.2 9.5H4.61536C5.34718 9.81893 6.15143 10 7 10C7.84791 10 8.65504 9.8192 9.38502 9.5H9.8C10.7259 9.5 11.5677 9.84917 12.2154 10.4213L10.1527 12.4839L9.90582 12.7308L9.78121 12.8554L9.76227 13.0306L9.72496 13.3758L9.72477 13.3775L9.51246 15.2789L9.51235 15.2799C9.50424 15.3539 9.50054 15.4273 9.50092 15.5ZM11.5003 15.4997L11.6931 13.7703L15.5249 9.94136L17.0585 11.475L13.2266 15.3069L11.5003 15.4997ZM10.5 4C10.5 5.93323 8.93323 7.5 7 7.5C5.06677 7.5 3.5 5.93323 3.5 4C3.5 2.06677 5.06677 0.5 7 0.5C8.93323 0.5 10.5 2.06677 10.5 4ZM18.2433 7.57231L19.4258 8.75478C19.4261 8.75504 19.4263 8.7553 19.4266 8.75556C19.5234 8.8543 19.5234 9.0114 19.4265 9.11012C19.4263 9.11036 19.4261 9.1106 19.4258 9.11084L18.4748 10.0619L16.9386 8.52788L17.8942 7.57231C17.9895 7.47694 18.148 7.47694 18.2433 7.57231Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6113_1517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserEdit);
export default __webpack_public_path__ + "static/media/profile-user-edit.d743e16b4f31506706d48cd1e838e05f.svg";
export { ForwardRef as ReactComponent };